import React from 'react'
import {
  EarningPaymentMethod,
  PaymentsTableFields,
  PaymentStatus,
  SingleFailureReasonType,
} from './enums'

export const paymentStatusTitle = {
  [PaymentStatus.Paid]: 'Paid',
  [PaymentStatus.Pending]: 'Pending',
}

export const PayoutMethodTitles = {
  [EarningPaymentMethod.Ach]: 'ACH',
  [EarningPaymentMethod.Instant]: 'Debit',
}

export const failureReasonTitles = {
  [SingleFailureReasonType.BadPayment]: 'Bad payment',
  [SingleFailureReasonType.ContractorNotOnboarded]: 'Contractor is not onboarded',
  [SingleFailureReasonType.ContractorDeactivated]: 'Contractor is deactivated',
  [SingleFailureReasonType.NoValidPaymentMethod]: 'No valid settlement method on file',
  [SingleFailureReasonType.UnsuccessfulPaymentAttempt]: 'Settlement attempt was unsuccessful',
  [SingleFailureReasonType.Unknown]: 'Reason unknown',
  [SingleFailureReasonType.PaymentCanceled]: 'Settlement was canceled',
}

export const PARA_BANK_DETAILS = {
  bankName: 'Webster Bank, N.A.',
  accountName: 'Para, Inc.',
  accountNumber: '7463692974',
  routingNumber: '021913655',
  accountType: 'Business Checking',
  bankAddress: 'One Jericho Plaza Suite 304, Jericho, NY 11753',
}

export const US_BANK_DETAILS = {
  bankName: 'U.S. Bank',
  accountType: 'Business Checking',
  bankAddress: '800 Nicollet Mall Minneapolis, MN 55402-7014',
}

export const paymentTableHeaderTitles: { [key in PaymentsTableFields]: string } = {
  [PaymentsTableFields.partnerDriverExternalId]: 'Contractors ID',
  [PaymentsTableFields.name]: 'Name',
  [PaymentsTableFields.marketName]: 'Market',
  [PaymentsTableFields.onboardingFlow]: 'Onboarding flow',
  [PaymentsTableFields.uploadedAt]: 'Added on',
  [PaymentsTableFields.status]: 'Status',
  [PaymentsTableFields.paidAt]: 'Paid on date',
  [PaymentsTableFields.payoutMethod]: 'Payout Method',
  [PaymentsTableFields.paid_to]: 'Paid to',
  [PaymentsTableFields.amount]: 'Amount',
  [PaymentsTableFields.netAmount]: 'Net amount',
}
